export default __webpack_public_path__ + "static/media/E2.2c541ca1.png";